import generateTypes from '../utils/generateTypes';

export const GET_COMMUNICATIONS = generateTypes('GET_COMMUNICATIONS');
export const RESET_COMMUNICATIONS = generateTypes('RESET_COMMUNICATIONS');
